<div class="agpr-madSentiment">
    <div class="agpr-madSentiment-cards">
        <div class="agpr-madSentiment-cards-card">
            <agpr-card-chart
                [series]="positiveCardSeries"
                [color]="cardChartComponentHighlightColors.positive"
                [bubbleTooltipMetric]="socialMetrics.POSITIVE"
                [headingLevel]="4"
            ></agpr-card-chart>
        </div>
        <div class="agpr-madSentiment-cards-card">
            <agpr-card-chart
                [series]="neutralCardSeries"
                [color]="cardChartComponentHighlightColors.neutral"
                [bubbleTooltipMetric]="socialMetrics.NEUTRAL"
                [headingLevel]="4"
            ></agpr-card-chart>
        </div>
        <div class="agpr-madSentiment-cards-card">
            <agpr-card-chart
                [series]="negativeCardSeries"
                [color]="cardChartComponentHighlightColors.negative"
                [bubbleTooltipMetric]="socialMetrics.NEGATIVE"
                [headingLevel]="4"
            ></agpr-card-chart>
        </div>
    </div>

    <!-- Sentiment Trend -->
    <div
        id="madSentimentTrend"
        #madSentimenTrendElement
        class="agpr-madSentiment-trend agpr-madSentiment-trend-noBottomPadding agpr-contextMenu-parent"
    >
        <div class="agpr-madSentiment-exportMenu agpr-contextMenu top right">
            <agpr-chart-export-menu
                id="shareOfVoiceBySocialNetwork_export"
                iconStyleClass="fa-regular fa-arrow-right-from-bracket"
                [supportedFormats]="[ 'png', 'jpg', 'svg', 'print' ]"
                (exportMenuClicked)="sentimentTrendExport($event, madSentimenTrendElement, madSentimentChartTypeEnum.COVERAGE_OVER_TIME)"
                [contextMenu]="true"
                [social]="true"
            ></agpr-chart-export-menu>
        </div>
        <div class="agpr-madSentiment-trend-header">
            <label class="agpr-madSentiment-sentimentByMediaTypeChart-title">{{ 'Monitor.MAD.sentiment.trend' | localize }}</label>
                <agpr-tabs
                    [(selectedTabIndex)]="selectedSentimentTrendChartTabIndex"
                    (selectedTabIndexChange)="sentimentTrendChartStackTypeChanged($event)"
                >
                    <agpr-tab
                        [id]="'madSentiment_sentimentTrendChart_percentage'"
                        [heading]="'Monitor.MAD.sentiment.sentimentByMediaType.' + stackTypes.percent"
                    ></agpr-tab>
                    <agpr-tab
                        [id]="'madSentiment_sentimentTrendChart_volume'"
                        [heading]="'Monitor.MAD.sentiment.sentimentByMediaType.' + stackTypes.count"
                    ></agpr-tab>
                </agpr-tabs>
        </div>
        <div class="agpr-mad-chartAnchor {{ sentimentTrendChartClass }}">
            <agpr-am5-chart
                [ngClass]="{ 'agpr-madSentiment-chart--noData': sentimentTrendChartNoData }"
                [chart]="sentimentTrendChart"
                [series]="sentimentTrendSeries"
                (noContent)="updateSentimentTrendChartNoData($event)"
                (tooltipLinkClick)="openAm5ChartDrilldown($event)"
            ></agpr-am5-chart>
        </div>
    </div>

    <div class="agpr-contextMenu-parent">
        <div
            #sentimentByMediaTypeElement
            class="agpr-mad-chartAnchor {{ sentimentByMediaTypeChartClass }}">
            <div class="agpr-madSentiment-exportMenu agpr-contextMenu top right">
                <agpr-chart-export-menu
                    id="sentimentByMediaTypeElement_export"
                    iconStyleClass="fa-regular fa-arrow-right-from-bracket"
                    [supportedFormats]="[ 'png', 'jpg', 'svg', 'print' ]"
                    (exportMenuClicked)="exportChart($event, sentimentByMediaTypeElement, madSentimentChartTypeEnum.SENTIMENT_BY_MEDIA_TYPE)"
                    [contextMenu]="true"
                    [social]="true"
                ></agpr-chart-export-menu>
            </div>
            <div class="agpr-madSentiment-sentimentByMediaTypeChart-topBar">
                <h4 class="agpr-madSentiment-sentimentByMediaTypeChart-title">
                    {{ 'Monitor.MAD.sentiment.sentimentByMediaType.label' | localize }}
                </h4>
                <agpr-tabs
                    [(selectedTabIndex)]="selectedSentimentByMediaChartTabIndex"
                    (selectedTabIndexChange)="sentimentByMediaTypeChartStackTypeChanged($event)"
                >
                    <agpr-tab
                        [id]="'madSentiment_sentimentByMediaTypeChart_percentage'"
                        [heading]="'Monitor.MAD.sentiment.sentimentByMediaType.' + stackTypes.percent"
                    ></agpr-tab>
                    <agpr-tab
                        [id]="'madSentiment_sentimentByMediaTypeChart_volume'"
                        [heading]="'Monitor.MAD.sentiment.sentimentByMediaType.' + stackTypes.count"
                    ></agpr-tab>
                </agpr-tabs>
            </div>
            @if (sentimentByMediaTypeChartNoData) {
                <agpr-message
                    class="agpr-madSentiment-chart-noContentMessage"
                    [severity]="messageSeverities.noContent"
                >
                    {{ 'Monitor.MAD.chart.noContentLabel' | localize }}
                </agpr-message>
            }
            <agpr-reports-chart
                [ngClass]="{ 'agpr-madSentiment-chart--noData': sentimentByMediaTypeChartNoData }"
                [chart]="sentimentByMediaTypeChart"
                (noContent)="updateSentimentByMediaTypeChartNoData($event)"
            ></agpr-reports-chart>
        </div>
    </div>

    <div class="agpr-madSentiment-sentimentContainer">
        <h3 class="agpr-madSentiment-sentimentContainer-title"> {{ 'Monitor.MAD.sentiment.positiveCoverage.label' | localize}} </h3>
        <div class="agpr-mad-chartAnchor">
            @if (positiveOutletsSeries) {
                <agpr-top-entities-chart-block
                    [block]="positiveOutletsBlock"
                    [series]="positiveOutletsSeries"
                    [entityType]="entityType.OUTLET"
                    [metricSelectable]="true"
                    [bigProfileImage]="true"
                    [height]="585"
                    [canViewProfileDetail]="true"
                    [shouldValidateSeries]="false"
                    (seriesChange)="topEntitiesChartSeriesUpdate($event)"
                ></agpr-top-entities-chart-block>
            }
        </div>
        <div class="agpr-mad-chartAnchor">
            @if (positiveAuthorsSeries) {
                <agpr-top-entities-chart-block
                    [block]="positiveAuthorsBlock"
                    [series]="positiveAuthorsSeries"
                    [entityType]="entityType.CONTACT"
                    [metricSelectable]="true"
                    [bigProfileImage]="true"
                    [height]="585"
                    [canViewProfileDetail]="true"
                    [shouldValidateSeries]="false"
                    (seriesChange)="topEntitiesChartSeriesUpdate($event)"
                ></agpr-top-entities-chart-block>
            }
        </div>
        <div #madSentimentPositiveMapElement class="agpr-madSentiment-map agpr-contextMenu-parent">
            <div class="agpr-madSentiment-exportMenu agpr-contextMenu top right">
                <agpr-chart-export-menu
                    id="madSentimentPositiveMapElement_export"
                    iconStyleClass="fa-regular fa-arrow-right-from-bracket"
                    [supportedFormats]="[ 'png', 'jpg', 'svg', 'print' ]"
                    (exportMenuClicked)="exportChart($event, madSentimentPositiveMapElement, madSentimentChartTypeEnum.GEOGRAPHY_BREAKDOWN_BY_VOLUME)"
                    [contextMenu]="true"
                    [social]="true"
                ></agpr-chart-export-menu>
            </div>
            <!-- positiveMapChartClass has to be the 2nd class in the list for the drilldown, so the ngClass is a hack becauses it always appends positiveMapChartClass at the end -->
            <div class="agpr-mad-chartAnchor {{ positiveMapChartClass }}"
                [ngClass]="{'agpr-madSentiment-mapChart': true}">
                <h4 class="agpr-madSentiment-mapChart-title">
                    <span class="agpr-madSentiment-mapChart-titleText">{{ 'Monitor.MAD.sentiment.positiveMap.label' | localize }} -</span>
                    <agpr-dropdown
                        class="agpr-madSentiment-metric-dropdown"
                        [style]="dropdownTypes.borderless"
                        [agprStyle]="agprComponentStyles.social"
                        panelStyleClass="agpr-dropdown-panelSocial"
                        [options]="mapChartDropdownOptions"
                        [(ngModel)]="selectedPositiveMapChartDropdownOption"
                        (ngModelChange)="mapChartDropdownOptionChanged($event, madSentimentSeriesTypes.positiveMap)"
                    ></agpr-dropdown>
                </h4>
                <agpr-reports-chart
                    [ngClass]="{ 'agpr-madSentiment-chart--noData': positiveMapChartNoData }"
                    [chart]="positiveMapChart"
                    (noContent)="updatePositiveMapChartNoData($event)"
                ></agpr-reports-chart>
                @if (positiveMapChartNoData) {
                    <agpr-message
                        class="agpr-madSentiment-chart-noContentMessage"
                        [severity]="messageSeverities.noContent"
                    >
                        {{ 'Monitor.MAD.chart.noContentLabel' | localize }}
                    </agpr-message>
                }
            </div>
        </div>
        <div #madSentimentPositiveWordCloudElement class="agpr-madSentiment-topTerms agpr-contextMenu-parent">
            <div class="agpr-madSentiment-exportMenu agpr-contextMenu top right">
                <agpr-chart-export-menu
                    id="madSentimentPositiveWordCloud_export"
                    iconStyleClass="fa-regular fa-arrow-right-from-bracket"
                    [supportedFormats]="[ 'png', 'jpg', 'svg', 'print' ]"
                    (exportMenuClicked)="exportChart($event, madSentimentPositiveWordCloudElement, madSentimentChartTypeEnum.WORD_CLOUD)"
                    [contextMenu]="true"
                    [social]="true"
                ></agpr-chart-export-menu>
            </div>

            <h4 class="agpr-madSentiment-mapChart-title">
                <span class="agpr-madSentiment-mapChart-titleText">{{ 'Monitor.MAD.sentiment.positiveTopTerm.label' | localize }}</span>
            </h4>
            <div class="agpr-madSentiment-topTerms-cards">
                <div class="agpr-madSentiment-topTerms-card">
                    @if (positiveTopTermsSeries) {
                        <agpr-top-terms-chart
                            [series]="[positiveTopTermsSeries]"
                            [header]="'Monitor.MAD.sentiment.positiveTopTerm.subLabel' | localize"
                            [accentColor]="positiveTopTermsSeries.color"
                            [chartOptions]="topTermsChartOptions"
                            (tooltipLinkClicked)="onTopTermsTooltipClicked($event, searchCriteriaQuerySentimentsEnum.positive)"
                            (termSelected)="selectTerm($event, searchCriteriaQuerySentimentsEnum.positive)"
                            [noContentMessage]="'Common.noContentToDisplay' | localize"
                        ></agpr-top-terms-chart>
                    }
                </div>

                <div
                    class="agpr-madSentiment-topTerms-card agpr-madSentiment-topTerms-card-related agpr-mad-chartAnchor {{ positiveWordCloudChartClass }}"
                    role="region"
                    tabindex="0"
                    attr.aria-labelledby="topTermsPositiveChartTitle"
                >
                    <h5 id="topTermsPositiveChartTitle">
                        <span class="agpr-madSentiment-topTerms-wordCloudTitle">
                            {{ 'Social.intelligence.charts.wordCloud.relatedTo' | localize }} {{ currentSelectedPositiveTerm }}
                        </span>
                    </h5>
                    @if (positiveWordCloudChart) {
                        <agpr-reports-chart
                            [chart]="positiveWordCloudChart"
                        ></agpr-reports-chart>
                    }
                </div>
            </div>
        </div>
    </div>
    <div class="agpr-madSentiment-sentimentContainer">
        <h3 class="agpr-madSentiment-sentimentContainer-title"> {{ 'Monitor.MAD.sentiment.negativeCoverage.label' | localize }} </h3>
        <div class="agpr-mad-chartAnchor">
            @if (negativeOutletsSeries) {
                <agpr-top-entities-chart-block
                    [block]="negativeOutletsBlock"
                    [series]="negativeOutletsSeries"
                    [entityType]="entityType.OUTLET"
                    [metricSelectable]="true"
                    [bigProfileImage]="true"
                    [height]="585"
                    [canViewProfileDetail]="true"
                    [shouldValidateSeries]="false"
                    (seriesChange)="topEntitiesChartSeriesUpdate($event)"
                ></agpr-top-entities-chart-block>
            }
        </div>
        <div class="agpr-mad-chartAnchor">
            @if (negativeAuthorsSeries) {
                <agpr-top-entities-chart-block
                    [block]="negativeAuthorsBlock"
                    [series]="negativeAuthorsSeries"
                    [entityType]="entityType.CONTACT"
                    [metricSelectable]="true"
                    [bigProfileImage]="true"
                    [height]="585"
                    [canViewProfileDetail]="true"
                    [shouldValidateSeries]="false"
                    (seriesChange)="topEntitiesChartSeriesUpdate($event)"
                ></agpr-top-entities-chart-block>
            }
        </div>
        <div #madSentimentNegativeMapElement class="agpr-madSentiment-map agpr-contextMenu-parent">
             <div class="agpr-madSentiment-exportMenu agpr-contextMenu top right">
                <agpr-chart-export-menu
                    id="madSentimentNegativeMapElement_export"
                    iconStyleClass="fa-regular fa-arrow-right-from-bracket"
                    [supportedFormats]="[ 'png', 'jpg', 'svg', 'print' ]"
                    (exportMenuClicked)="exportChart($event, madSentimentNegativeMapElement, madSentimentChartTypeEnum.GEOGRAPHY_BREAKDOWN_BY_VOLUME)"
                    [contextMenu]="true"
                    [social]="true"
                ></agpr-chart-export-menu>
            </div>
            <!-- negativeMapChartClass has to be the 2nd class in the list for the drilldown, so the ngClass is a hack becauses it always appends negativeMapChartClass at the end -->
            <div class="agpr-mad-chartAnchor {{ negativeMapChartClass }}"
                [ngClass]="{'agpr-madSentiment-mapChart': true}">
                <h4 class="agpr-madSentiment-mapChart-title">
                    <span class="agpr-madSentiment-mapChart-titleText">{{ 'Monitor.MAD.sentiment.negativeMap.label' | localize }} -</span>
                    <agpr-dropdown
                        class="agpr-madSentiment-metric-dropdown"
                        [style]="dropdownTypes.borderless"
                        [agprStyle]="agprComponentStyles.social"
                        panelStyleClass="agpr-dropdown-panelSocial"
                        [options]="mapChartDropdownOptions"
                        [(ngModel)]="selectedNegativeMapChartDropdownOption"
                        (ngModelChange)="mapChartDropdownOptionChanged($event, madSentimentSeriesTypes.negativeMap)"
                    ></agpr-dropdown>
                </h4>
                <agpr-reports-chart
                    [ngClass]="{ 'agpr-madSentiment-chart--noData': negativeMapChartNoData }"
                    [chart]="negativeMapChart"
                    (noContent)="updateNegativeMapChartNoData($event)"
                ></agpr-reports-chart>
                @if (negativeMapChartNoData) {
                    <agpr-message
                        class="agpr-madSentiment-chart-noContentMessage"
                        [severity]="messageSeverities.noContent"
                    >
                        {{ 'Monitor.MAD.chart.noContentLabel' | localize }}
                    </agpr-message>
                }
            </div>
        </div>
        <div #madSentimentNegativeWordCloudElement class="agpr-madSentiment-topTerms  agpr-contextMenu-parent">
            <div class="agpr-madSentiment-exportMenu agpr-contextMenu top right">
                <agpr-chart-export-menu
                    id="madSentimentNegativeWordCloud_export"
                    iconStyleClass="fa-regular fa-arrow-right-from-bracket"
                    [supportedFormats]="[ 'png', 'jpg', 'svg', 'print' ]"
                    (exportMenuClicked)="exportChart($event, madSentimentNegativeWordCloudElement, madSentimentChartTypeEnum.WORD_CLOUD)"
                    [contextMenu]="true"
                    [social]="true"
                ></agpr-chart-export-menu>
            </div>
            <h4 class="agpr-madSentiment-mapChart-title">
                <span class="agpr-madSentiment-mapChart-titleText">{{ 'Monitor.MAD.sentiment.negativeTopTerm.label' | localize }}</span>
            </h4>
            <div class="agpr-madSentiment-topTerms-cards">
                <div class="agpr-madSentiment-topTerms-card">
                    @if (negativeTopTermsSeries) {
                        <agpr-top-terms-chart
                            [series]="[negativeTopTermsSeries]"
                            [header]="'Monitor.MAD.sentiment.negativeTopTerm.subLabel' | localize"
                            [accentColor]="negativeTopTermsSeries.color"
                            [chartOptions]="topTermsChartOptions"
                            (tooltipLinkClicked)="onTopTermsTooltipClicked($event, searchCriteriaQuerySentimentsEnum.negative)"
                            (termSelected)="selectTerm($event, searchCriteriaQuerySentimentsEnum.negative)"
                            [noContentMessage]="'Common.noContentToDisplay' | localize"
                        ></agpr-top-terms-chart>
                    }
                </div>
                <div
                    class="agpr-mad-chartAnchor {{ negativeWordCloudChartClass }} agpr-madSentiment-topTerms-card agpr-madSentiment-topTerms-card-related "
                    role="region"
                    tabindex="0"
                    attr.aria-labelledby="topTermsNegativeChartTitle"
                >
                    <h5 id="topTermsNegativeChartTitle"
                    >
                        <span class="agpr-madSentiment-topTerms-wordCloudTitle">
                            {{ 'Social.intelligence.charts.wordCloud.relatedTo' | localize }} {{ currentSelectedNegativeTerm }}
                        </span>
                    </h5>
                    @if (negativeWordCloudChart) {
                        <agpr-reports-chart
                            [chart]="negativeWordCloudChart"
                        ></agpr-reports-chart>
                    }
                </div>
            </div>
        </div>
    </div>

        <div id="madSentimentTopMentions" #madSentimentTopMentionsElement class="agpr-madSentiment-topMentions agpr-mad-chartAnchor agpr-second-contextMenu-parent">
            <div class="agpr-madSentiment-topMentions-export agpr-second-contextMenu top right">
                <agpr-chart-export-menu
                    id="madSentimentTopMentions_export"
                    iconStyleClass="fa-regular fa-arrow-right-from-bracket"
                    [supportedFormats]="[ 'png', 'jpg', 'svg', 'print' ]"
                    (exportMenuClicked)="topMentionsExport($event, madSentimentTopMentionsElement, madSentimentChartTypeEnum.TOP_MENTIONS)"
                    [contextMenu]="true"
                    [social]="true"
                ></agpr-chart-export-menu>
            </div>
            @if (topMentionsSeries) {
                <agpr-top-mentions-mad-chart
                    [series]="topMentionsSeries"
                    [hasSentimentDropdown]="true"
                    (seriesChange)="topMentionsSeriesChange($event)"
                    (openDrilldown)="openTopMentionsDrilldown()"
                ></agpr-top-mentions-mad-chart>
        }
    </div>
</div>
